





































































import { Component, Prop, Vue } from "vue-property-decorator"
import { mapState, mapGetters } from "vuex"
import { METHODS, INVOICE_STATUSES } from "@/constants/payment"
import { STATUSES } from "@/constants/booking"

@Component({
  computed: {
    ...mapState({
      loading: "loading",
    }),
    ...mapState("Auth", {
      activeBusiness: "activeBusiness",
    }),
    ...mapState("Booking", {
      booking: "booking",
    }),
    ...mapGetters("Auth", {
      hasValidatedCreditLimit: "hasValidatedCreditLimit",
    }),
    ...mapGetters("ServiceItem", {
      assessmentAvailable: "assessmentAvailable",
    }),
  },
})
export default class BookingReadServiceOrderPaymentMethods extends Vue {
  @Prop() readonly create!: () => void

  paymentMethods = METHODS
  invoiceStatuses = INVOICE_STATUSES
  statuses = STATUSES
  invoiceStatus = null

  activeBusiness!: Model
  booking!: Booking

  website = process.env.VUE_APP_WP_BASE || ''

  hasValidatedCreditLimit!: boolean

  assessmentAvailable!: number

  poNumber = null

  beforeMount() {
    if (!this.isInvoiceUnauthorized) {
      this.$store.dispatch("Booking/checkCreditLimit").then((response) => {
        this.invoiceStatus = response.data.data
      })
    }
  }

  placeInvoiceOrder() {
    if (!this.hasValidatedCreditLimit) {
      return
    }

    const serviceOrder = {
      business_oid: this.activeBusiness.object_id,
      booking_oid: this.booking.object_id,
      payment_method: this.paymentMethods.INVOICE.key,
      po_number: this.poNumber,
    }
    this.$store
      .dispatch("ServiceOrder/create", serviceOrder)
      .then((invoiceStatus) => {
        this.invoiceStatus = invoiceStatus
        if (!this.isInvoiceInsuffientCredit && !this.isInvoiceUnauthorized) {
          // if success, consume the booking
          this.consume()
        }
      })
  }

  get isEnoughAssessment() {
    return this.assessmentAvailable >= this.booking.candidate_number
  }

  get isInvoiceInsuffientCredit() {
    return (
      this.invoiceStatus ==
      this.invoiceStatuses.INVOICE_STATUS_INSUFFICIENT_CREDIT.key
    )
  }

  get isInvoiceUnauthorized() {
    return (
      this.invoiceStatus ==
        this.invoiceStatuses.INVOICE_STATUS_UNAUTHORIZED.key ||
      !this.hasValidatedCreditLimit
    )
  }

  async consume() {
    this.$emit("consume")
  }

  toCreditCheck() {
    this.$router.push({
      name: "business-credit-check",
    })
  }

  toTermsAndConditions() {
    this.$router.push({
      name: "terms-and-conditions",
    })
  }
}
